import dateFormat from 'dateformat';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@morressier/alembic';
import ReviewSummaryAccordion from '../../decisionModals/ReviewSummaries';
import { IRoleType } from '@publishing-engine/domain/models';
import { faFileImport } from '@fortawesome/pro-light-svg-icons';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';

interface Props {
  submissionId: string;
  onClose: () => void;
  deadline?: Date;
  role: IRoleType;
}

export const EditorialTransferOfferContextModal = ({
  onClose,
  deadline
}: Props) => {
  const { transferOffer: data } = useSubmissionData();

  if (!data) return null;

  return (
    <Modal
      isOpen
      closeButtonProps={{
        hidden: true
      }}
      onClose={onClose}
      width="720px"
    >
      <Flex
        padding={8}
        gap={6}
        flexDirection="column"
        maxHeight="80vh"
        overflow="auto"
      >
        <Box>
          <FontAwesomeIcon fontSize={32} icon={faFileImport} />
        </Box>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Transfer Context</Text>
        </Flex>
        <Flex gap={2} flexDirection="column">
          <Text textStyle="headingItem">Deadline</Text>
          <Text textStyle="textBody">
            {dateFormat(deadline, 'mmmm d, yyyy')}
          </Text>
        </Flex>

        <Flex gap={2} flexDirection="column">
          <Text textStyle="headingItem">Offered Transfer Journals</Text>
          <Box paddingStart={2}>
            <ul>
              {data.targetJournals.map(journal => (
                <li key={journal.id}>
                  <Text textStyle="textBody">{journal.name}</Text>
                </li>
              ))}
            </ul>
          </Box>
        </Flex>

        {data.transferReason && (
          <Flex gap={2} flexDirection="column">
            <Text textStyle="headingItem">Transfer Reason </Text>
            <Text textStyle="textBody">{data.transferReason}</Text>
          </Flex>
        )}

        {data.editorComment && (
          <Flex gap={2} flexDirection="column">
            <Text textStyle="headingItem">Response to Author </Text>
            <Text textStyle="textBody">{data.editorComment}</Text>
          </Flex>
        )}

        <ReviewSummaryAccordion reviews={data.reviewerFeedback ?? []} />
        <Flex
          gap={2}
          justifyContent="flex-end"
          alignItems="center"
          alignSelf="stretch"
        >
          <Button
            onClick={onClose}
            variant="primary"
            type="submit"
            borderRadius="small"
          >
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
